import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import PropTypes from "prop-types";
import ShowData from "./ShowData";
import DateFilterStart from "./DateFilterStart";
import DateFilterEnd from "./DateFilterEnd";
import ButtonsFilter from "./ButtonsFilter";
import moment from "moment-timezone";
import "moment/locale/es";
moment.locale("es");

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },
  paper: {
    height: 140,
    width: 100
  },
  buttonMargin: {
    marginTop: "3px",
    marginBottom: "3px"
  },
  container: {
    display: "flex",
    flexWrap: "wrap"
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200
  }
}));

const GraphicComponent = props => {
  const classes = useStyles();
  const {
    activos,
    graphicData,
    startDate,
    endDate,
    handleDateStartChange,
    handleDateEndChange,
    Ingresos,
    Egresos,
    Balance,
    handleChangeFilters,
    checkFilter,
    totalBalance
  } = props;

  return (
    <Grid container className={classes.root} spacing={2}>
      <Grid item xs={1} />
      <Grid item xs={10} container>
        <Grid item xs={12} container justify="center">
          <Grid item xs={1} />
          <Grid item xs={4}>
            <DateFilterStart
              startDate={startDate}
              handleDateStartChange={handleDateStartChange}
            />
          </Grid>
          <Grid item xs={2} />
          <Grid item xs={4}>
            <DateFilterEnd
              endDate={endDate}
              handleDateEndChange={handleDateEndChange}
            />
          </Grid>
          <Grid item xs={1} />
        </Grid>
        <Grid item xs={12} container justify="center">
          <ButtonsFilter
            Ingresos={Ingresos}
            Egresos={Egresos}
            Balance={Balance}
            handleChangeFilters={handleChangeFilters}
            checkFilter={checkFilter}
          />
        </Grid>
        <Grid item xs={12} container justify="center">
          <Typography
            variant="body1"
            gutterBottom
            style={{ fontWeight: "bold" }}
          >
            Balance:
          </Typography>
          <Typography variant="body1" gutterBottom>
            {parseFloat(totalBalance).toFixed(1)}
          </Typography>
        </Grid>
        <Grid item xs={12} container justify="center">
          <Grid
            item
            xs={12}
            align="center"
            style={{ marginTop: "3em", marginBottom: "3em" }}
          >
            <ShowData graphicData={graphicData} activos={activos} />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={1} />
    </Grid>
  );
};

export default GraphicComponent;

GraphicComponent.propTypes = {
  activos: PropTypes.array,
  graphicData: PropTypes.array,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  handleDateStartChange: PropTypes.func,
  handleDateEndChange: PropTypes.func,
  getFilterOne: PropTypes.array,
  getFilterTwo: PropTypes.array,
  Ingresos: PropTypes.bool,
  Egresos: PropTypes.bool,
  Balance: PropTypes.bool,
  handleChangeFilters: PropTypes.func,
  checkFilter: PropTypes.bool,
  totalBalance: PropTypes.number
};
